import { useState, useEffect } from 'react';
import useCustomNavigate from '../../../hooks/useCustomNavigate';
import { Modal, Divider, Form, Input, Button, message, Checkbox, Row, Col, Typography } from 'antd';
import axios from "./../../../services/http";

const ModalFormPerfil = ({ action, profileData, openDialogProfile, cancelDialogProfile, realodData }) => {

    const navigate = useCustomNavigate();
    const [profileForm] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        GetProfileBase();
    }, []);

    useEffect(() => {
        if (profileData) GetProfileById();
    }, [profileData]);

    const GetProfileBase = async () => {
        try {
            const response = await axios.HTTP_GET("/api/v1/profiles/get/base");
            setPermissions(response);
            
        } catch (error) {
            console.error('Error al cargar los permisos:', error);
            message.error('Error al cargar los permisos: ', error);
        } finally {
            setLoading(false);
        }
    }

    const GetProfileById = async () => {
        try {
            const response = await axios.HTTP_GET(`/api/v1/profiles/byId/${profileData}`);
            profileForm.setFieldsValue({ name: response.name, permissions: response.permissions });

        } catch (error) {
            console.error('Error al cargar el perfil:', error);
            message.error('Error al cargar el perfil: ', error);
        } finally {
            setLoading(false);
        }
    }

    const onChange = checkedValues => {
        profileForm.setFieldsValue({ permissions: checkedValues });
    };

    const handlePending = async (values) => {
        if (!values.permissions || values.permissions.length < 1) {
            message.warning("Debe seleccionar un permiso.");
            return;
        } else {
            try {
                setLoading(true);
                if (action === "update") values["id"] = profileData
                const hide = message.loading('Guardando perfil, espere un momento..', 0);
                let url = action === "create" ? "/api/v1/profiles/save" : "/api/v1/profiles/update";
                const response = await axios.HTTP_POST(url, values);

                if (response) {
                    hide();
                    message.success(response.data.message);
                    cancelDialogProfile(false);
                    profileForm.resetFields();
                    realodData();
                }

            } catch (error) {
                console.error('Error al guardar el perfil:', error);
                message.error('Error al guardar el perfil: ', error);
            } finally {
                setLoading(false);
            }
        }
    }

    return (
        <>
            <Modal
                title={`${action === "create" ? "Nuevo" : "Editar"} perfil`}
                open={openDialogProfile}
                onCancel={() => cancelDialogProfile(false)}
                footer={null}
                width={{
                    xs: '90%',
                    sm: '80%',
                    md: '70%',
                    lg: '60%',
                    xl: '50%',
                    xxl: '50%',
                }}
                >
                <Divider style={{ margin: '24px 0' }} />
                <Form
                    layout="vertical"
                    form={profileForm}
                    onFinish={handlePending}
                >
                    <Form.Item
                        label="Nombre"
                        name="name"
                        rules={[{ required: true, message: 'Por favor ingresar el nombre del perfil' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Typography.Title level={4}>Permisos</Typography.Title>
                    <Form.Item
                        name="permissions"
                    >
                        <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
                            <Row>
                                {permissions.length > 0 && permissions.map(item => (
                                    <Col span={12} key={item.name}>
                                        <Checkbox className='mb-5' value={item.id}>{ item.descripcion }</Checkbox>
                                    </Col>
                                ))}
                            </Row>
                        </Checkbox.Group>
                    </Form.Item>

                    <Divider style={{ margin: '24px 0' }} />
                    <Form.Item>
                        <div className='w-full flex flex-end gap-10'>
                            <Button type="default" onClick={() => { profileForm.resetFields(); cancelDialogProfile(false); }}>
                                Cancelar
                            </Button>
                            <Button type="primary" loading={loading} htmlType="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModalFormPerfil;